import { render, staticRenderFns } from "./FollowupsUiToggle.vue?vue&type=template&id=24b3ddcc&scoped=true"
import script from "./FollowupsUiToggle.vue?vue&type=script&lang=js"
export * from "./FollowupsUiToggle.vue?vue&type=script&lang=js"
import style0 from "./FollowupsUiToggle.vue?vue&type=style&index=0&id=24b3ddcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3ddcc",
  null
  
)

export default component.exports